import { createSlice } from '@reduxjs/toolkit';

const appStateInitialState = {
  prefixLanguage: 'en',
  language: 'en',
  direction: 'ltr',
  token: null,
  isLoggedIn: false,
  isLoading: true,
  hasGigyaLoaded: false,
  showModal: false,
  modalProps: {},
  loginRedirectRoute: '',
};

const appStateSlice = createSlice({
  name: 'appState',
  initialState: appStateInitialState,
  reducers: {
    gigyaLoaded(state) {
      state.hasGigyaLoaded = true;
    },
    appLogin(state, { payload }) {
      state.token = payload; // payload: access_token
      state.isLoggedIn = true;
    },
    appLogout(state) {
      state.token = null;
      state.isLoggedIn = false;
    },
    toggleLoading(state, { payload }) {
      state.isLoading = payload;
    },
    displayModal(state, { payload }) {
      state.modalProps = payload;
      state.showModal = true;
    },
    hideModal(state) {
      state.modalProps = {};
      state.showModal = false;
    },
    appPrefixLanguage(state, { payload }) {
      state.prefixLanguage = payload;
    },
    appLanguage(state, { payload }) {
      state.language = payload;
    },
    appDirection(state, { payload }) {
      state.direction = payload;
    },
    setLoginRedirectRoute(state, { payload }) {
      state.loginRedirectRoute = payload;
    },
  },
});

export const {
  gigyaLoaded,
  appLogin,
  appLogout,
  toggleLoading,
  displayModal,
  hideModal,
  appPrefixLanguage,
  appLanguage,
  appDirection,
  setLoginRedirectRoute,
} = appStateSlice.actions;

export default appStateSlice.reducer;
